/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  DegroupTraceabilityRequestMutationRequest,
  DegroupTraceabilityRequestMutationResponse,
  DegroupTraceabilityRequestPathParams,
} from "../types/DegroupTraceabilityRequest.ts"
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { mutationOptions, useMutation } from "@tanstack/react-query"

export const degroupTraceabilityRequestMutationKey = () =>
  [{ url: "/v1/traceability-requests/:id/degroup" }] as const

export type DegroupTraceabilityRequestMutationKey = ReturnType<
  typeof degroupTraceabilityRequestMutationKey
>

/**
 * @summary Degroup traceability request
 * {@link /v1/traceability-requests/:id/degroup}
 */
export async function degroupTraceabilityRequest(
  id: DegroupTraceabilityRequestPathParams["id"],
  data: DegroupTraceabilityRequestMutationRequest,
  config: Partial<RequestConfig<DegroupTraceabilityRequestMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    DegroupTraceabilityRequestMutationResponse,
    ResponseErrorConfig<Error>,
    DegroupTraceabilityRequestMutationRequest
  >({
    method: "POST",
    url: `/v1/traceability-requests/${id}/degroup`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function degroupTraceabilityRequestMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<DegroupTraceabilityRequestMutationRequest>> & {
    client?: Client
  } = {}
) {
  const mutationKey = degroupTraceabilityRequestMutationKey()
  return mutationOptions<
    ResponseConfig<DegroupTraceabilityRequestMutationResponse>,
    ResponseErrorConfig<Error>,
    {
      id: DegroupTraceabilityRequestPathParams["id"]
      data: DegroupTraceabilityRequestMutationRequest
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id, data }) => {
      return degroupTraceabilityRequest(id, data, config)
    },
  })
}

/**
 * @summary Degroup traceability request
 * {@link /v1/traceability-requests/:id/degroup}
 */
export function useDegroupTraceabilityRequest<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<DegroupTraceabilityRequestMutationResponse>,
      ResponseErrorConfig<Error>,
      {
        id: DegroupTraceabilityRequestPathParams["id"]
        data: DegroupTraceabilityRequestMutationRequest
      },
      TContext
    > & { client?: QueryClient }
    client?: Partial<
      RequestConfig<DegroupTraceabilityRequestMutationRequest>
    > & { client?: Client }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? degroupTraceabilityRequestMutationKey()

  const baseOptions = degroupTraceabilityRequestMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<DegroupTraceabilityRequestMutationResponse>,
    ResponseErrorConfig<Error>,
    {
      id: DegroupTraceabilityRequestPathParams["id"]
      data: DegroupTraceabilityRequestMutationRequest
    },
    TContext
  >

  return useMutation<
    ResponseConfig<DegroupTraceabilityRequestMutationResponse>,
    ResponseErrorConfig<Error>,
    {
      id: DegroupTraceabilityRequestPathParams["id"]
      data: DegroupTraceabilityRequestMutationRequest
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<DegroupTraceabilityRequestMutationResponse>,
    ResponseErrorConfig<Error>,
    {
      id: DegroupTraceabilityRequestPathParams["id"]
      data: DegroupTraceabilityRequestMutationRequest
    },
    TContext
  >
}
